/**
 * 校园亲情话机相关
 * 接口地址 http://rap2.10niu.cn/repository/editor?id=137&mod=641
 * 原型地址 https://lda5r1.axshare.com/#id=qh0gwh&p=%E4%BA%B2%E6%83%85%E8%AF%9D%E6%9C%BA-%E5%A5%97%E9%A4%90%E8%AE%BE%E7%BD%AE&g=1&hi=1
 */
/**
 * 亲情话机v1.3
 * 接口地址: http://rap2.10niu.cn/repository/editor?id=137&mod=655&itf=4262
 * 前端方案：https://note.youdao.com/s/40zlpGM9
 * 后端方案：https://note.youdao.com/s/Gcjv3wj5
 * 原型地址：https://kg6bbm.axshare.com/#g=1&p=%E7%94%A8%E6%88%B7%E7%AE%A1%E7%90%86&hi=1
 */
import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import qs from 'qs';

const kinshipPhone = {
	// 后台_亲情电话_套餐_列表
	packageList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/family_phone/v1/package/list`,
			headers: config.headers,
			params
		});
	},
	// 后台_亲情电话_套餐_设置
	packageSet(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/family_phone/v1/package/set`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 后台_亲情电话_套餐_详情
	packageInfor(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/family_phone/v1/package/info`,
			headers: config.headers,
			params
		});
	},
	// 后台_亲情电话_用户_列表
	userList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/family_phone/v1/user/list`,
			headers: config.headers,
			params
		});
	},
	// 后台_亲情电话_订单_列表
	orderList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/family_phone/v1/order/list`,
			headers: config.headers,
			params
		});
	},
	// 后台_亲情电话_账户管理_获取代理商商户列表
	merchantList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/family_phone/v1/agent/merchant_list`,
			headers: config.headers,
			params
		});
	},
	// 后台_亲情电话_账户管理_获取代理商商户配置
	merchantInfo(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/family_phone/v1/merchant/info`,
			headers: config.headers,
			params
		});
	},
	// 后台_亲情电话_账户管理_保存代理商商户设置
	merchantSave(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/family_phone/v1/merchant/save`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 后台_亲情电话_分账_获取默认配置
	getDefaultConfig(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/family_phone/v1/profitsharing/default_config`,
			headers: config.headers,
			params
		});
	},
	// 后台_亲情电话_分账_获取商户分账比例
	merchantConfig(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/family_phone/v1/profitsharing/merchant_config`,
			headers: config.headers,
			params
		});
	},
	// 后台_亲情电话_分账_获取商户分账关系
	profitsharingRelation(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/family_phone/v1/profitsharing/relation`,
			headers: config.headers,
			params
		});
	},
	// 后台_亲情电话_分账_获取学校分账设置
	getProfitsharing(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/family_phone/v1/profitsharing/get`,
			headers: config.headers,
			params
		});
	},
	// 后台_亲情电话_分账_保存学校分账设置
	setProfitsharing(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/family_phone/v1/profitsharing/set`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 后台_亲情电话_分账_关闭学校分账
	closeProfitsharing(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/family_phone/v1/profitsharing/close`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 后台_亲情电话_服务管理_学校分账列表
	getSchoolAubAccountList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/family_phone/v1/school/list`,
			headers: config.headers,
			params
		});
	},
	// 后台_亲情电话_通话_列表
	getCallList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/family_phone/v1/call/list`,
			headers: config.headers,
			params
		});
	},
	// 后台_亲情电话_设备管理_获取分组列表
	getGroupList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/family_phone/v1/group/list`,
			headers: config.headers,
			params
		});
	},
	// 后台_亲情电话_设备管理_获取设备列表
	getDeviceList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/family_phone/v1/device/list`,
			headers: config.headers,
			params
		});
	},
	// 后台_亲情电话_设备管理_添加设备
	deviceAdd(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/family_phone/v1/device/add`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 后台_亲情电话_设备管理_获取未注册设备
	getUnregisterDeviceList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/family_phone/v1/device/unregister_device_list`,
			headers: config.headers,
			params
		});
	},
	// 后台_亲情电话_订单_详情
	orderInfo(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/family_phone/v1/order/info`,
			headers: config.headers,
			params
		});
	},
	// 后台_亲情电话_设备管理_获取设备详情
	getDeviceInfo(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/family_phone/v1/device/info`,
			headers: config.headers,
			params
		});
	},
	//后台_亲情电话_设备管理_编辑设备
	deviceSet(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/family_phone/v1/device/set`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 后台_亲情电话_设备管理_注册设备
	deviceRegister(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/family_phone/v1/device/register`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 后台_亲情电话_学校配置_获取
	getConfigInfo(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/family_phone/v121/school/config_info`,
			headers: config.headers,
			params
		});
	},
	// 后台_亲情电话_学校配置_添加
	setConfig(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/family_phone/v121/school/set_config`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 亲情电话_V130_人工开通
	manualOpen(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/family_phone/v130/manual/open`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 亲情电话_V130_表格导入
	tableImport(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/family_phone/v130/table/import`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 亲情电话_V130_表格开通
	tableOpen(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/family_phone/v130/table/open`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 亲情电话_V130_订单详情
	getOrderInfor(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/family_phone/v130/agent_order/info`,
			headers: config.headers,
			params
		});
	},
	// 后台_亲情电话_增值模式_设置套餐
	setPackage(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/family-phone/added-value-mode/set-package`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 后台_亲情电话_增值模式_开通
	userOpen(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/family-phone/added-value-mode/user-open`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 后台_亲情电话_用户_设置是否允许拨号
	setTell(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/family_phone/v1/user/set_tell`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	}
};
export default kinshipPhone;
